import * as THREE from 'three'

import BaseObject from './baseObject'


// Review Highlight Object
// Displays the bounds for the currently highlighted review item during order editor review
export default class ReviewHighlightObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.displayRegion = new THREE.Box2()

    this.outlineGeom = null
    this.innerGeom = null
    this.outlineObj = null
    this.innerObj = null

    this.sceneObject = new THREE.Object3D()
  }

  // Dispose
  dispose() {
    super.dispose()

    if(this.outlineGeom) {
      this.outlineGeom.dispose()
      this.outlineGeom = null
    }
    if(this.innerGeom) {
      this.innerGeom.dispose()
      this.innerGeom = null
    }
    this.outlineObj = null
    this.innerObj = null
  }


  // Update the display region of the object
  updateDisplayRegion(bounds) {
    this.displayRegion.set(bounds.min, bounds.max)

    // If the bounds are too small, pad it out
    var regionScale = 1.0 / this.editor.camera.zoom
    var minSize = 15 * regionScale

    var expandVec = new THREE.Vector2(0, 0)
    if(this.displayRegion.max.x - this.displayRegion.min.x < minSize)
      expandVec.x = minSize/2
      if(this.displayRegion.max.y - this.displayRegion.min.y < minSize)
      expandVec.y = minSize/2
    this.displayRegion.expandByVector(expandVec)

    this.updateSceneObject()
  }


  /**
   * Build the initial drawing objects to display the review region
   */
  updateSceneObject() {
    if(this.outlineGeom) {
      this.outlineGeom.dispose()
      this.outlineGeom = null
    }
    if(this.innerGeom) {
      this.innerGeom.dispose()
      this.innerGeom = null
    }
    this.outlineObj = null
    this.innerObj = null

    this.clearSceneObject()

    var colour = this.editor.getTheme().reviewHighlightColour
    var outlineOpacity = 0.5
    var regionOpacity = this.editor.getTheme().reviewHighlightRegionOpacity

    var meshVertices = []
    var lineVertices = []
    var layerZ = 100;
    lineVertices.push(this.displayRegion.min.x, this.displayRegion.min.y, layerZ, this.displayRegion.max.x, this.displayRegion.min.y, layerZ)
    lineVertices.push(this.displayRegion.max.x, this.displayRegion.min.y, layerZ, this.displayRegion.max.x, this.displayRegion.max.y, layerZ)
    lineVertices.push(this.displayRegion.max.x, this.displayRegion.max.y, layerZ, this.displayRegion.min.x, this.displayRegion.max.y, layerZ)
    lineVertices.push(this.displayRegion.min.x, this.displayRegion.max.y, layerZ, this.displayRegion.min.x, this.displayRegion.min.y, layerZ)

    meshVertices.push(this.displayRegion.min.x, this.displayRegion.min.y, layerZ, this.displayRegion.max.x, this.displayRegion.min.y, layerZ, this.displayRegion.max.x, this.displayRegion.max.y, layerZ)
    meshVertices.push(this.displayRegion.min.x, this.displayRegion.min.y, layerZ, this.displayRegion.max.x, this.displayRegion.max.y, layerZ, this.displayRegion.min.x, this.displayRegion.max.y, layerZ)

    this.innerGeom = new THREE.BufferGeometry();
    this.innerGeom.setAttribute('position', new THREE.Float32BufferAttribute(meshVertices, 3))
    this.innerGeom.computeVertexNormals()

    var innerMaterial = new THREE.MeshBasicMaterial({
      color: colour,
      transparent: true,
      opacity: regionOpacity,
      side: THREE.DoubleSide
    })
    this.innerObj = new THREE.Mesh(this.innerGeom, innerMaterial)
    this.sceneObject.add(this.innerObj)

    this.outlineGeom = new THREE.BufferGeometry();
    this.outlineGeom.setAttribute('position', new THREE.Float32BufferAttribute(lineVertices, 3))
    this.outlineGeom.computeVertexNormals()

    var outlineMaterial = new THREE.LineBasicMaterial({
      color: colour,
      transparent: true,
      opacity: outlineOpacity,
    })
    this.outlineObj = new THREE.LineSegments(this.outlineGeom, outlineMaterial)
    this.sceneObject.add(this.outlineObj)
  }
}
